import { isAgentHubEnabled } from 'agentHub/selectors/isAgentHubEnabled'
import { HOTELS_ENABLED_FILTERS } from 'constants/search'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import { createSelector } from 'reselect'

export const getHotelEnabledFilters = createSelector(
  (state: App.State) => getIsLuxPlusEnabled(state),
  (luxPlusEnabled) => {
    return {
      ...HOTELS_ENABLED_FILTERS,
      luxPlusFeatures: luxPlusEnabled,
      agentHubFeatures: isAgentHubEnabled,
    }
  },
)
